import React from "react";

import { H2 } from "components/core/Typography";
import { ReviewsList } from "components/review/ReviewsList";

import "./Reviews.scss";

const Reviews = ({ ...rest }) => (
    <div
        className="reviews-section-v2"
        id="reviews"
    >
        <H2
            size="xxlarge"
        >
            What People Say About This Facility
        </H2>
        <ReviewsList {...rest} hideHeading/>
    </div>
);

export default Reviews;
